<script>
import { mapActions } from 'vuex'

export default {
  name: 'LogDetails',
  page: {
    title: 'Log Details',
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      details: {},
    }
  },
  computed: {
    status() {
      const { status } = this.details
      const type = status.toString()[0]

      return `${status} ${type === '2' ? 'OK' : 'ERR'}`
    },
    path() {
      const { requestPath, requestQuery } = this.details
      let path = requestPath

      if (requestQuery) {
        path += `?${requestQuery}`
      }

      return path
    },
    request() {
      return `${this.details.requestMethod} ${this.path}`
    },
    createdBy() {
      const { createdBy } = this.details

      if (createdBy) {
        return `${createdBy.firstName} ${createdBy.lastName} (User ID:${createdBy.id})`
      }

      return '—'
    },
    formattedRequestBody() {
      const { requestBody } = this.details

      if (requestBody) {
        return JSON.stringify(JSON.parse(requestBody), null, 2)
      }

      return ''
    },
    formattedResponseBody() {
      const { responseBody } = this.details

      if (responseBody) {
        return JSON.stringify(JSON.parse(responseBody), null, 2)
      }

      return ''
    },
  },
  async created() {
    const [error, result] = await this.getLogRecord(this.id)

    if (error) {
      this.$router.replace({ name: 'logs' })
    } else {
      this.details = result

      this.loading = false
    }
  },
  methods: {
    ...mapActions('log', ['getLogRecord']),
  },
}
</script>

<template>
  <main-layout
    :back="{ name: 'logs' }"
    title="Log Details"
    :loading="loading"
  >
    <data-box
      header="Summary"
      :status="false"
    >
      <data-list
        v-if="!loading"
        class="datalist"
      >
        <dt>Date Created</dt>
        <dd>{{ details.createdAt | dateTime }}</dd>

        <dt>Last Update</dt>
        <dd>{{ details.updatedAt | dateTime }}</dd>

        <dt>Updated by</dt>
        <dd>
          {{ createdBy }}
        </dd>

        <dt>Status</dt>
        <dd>{{ details.responseStatusCode }}</dd>

        <dt>Log</dt>
        <dd>{{ request }}</dd>

        <dt>ID</dt>
        <dd>{{ details.id }}</dd>

        <dt>Method</dt>
        <dd>{{ details.requestMethod }}</dd>

        <dt>URL</dt>
        <dd>{{ path }}</dd>

        <dt>IP Address</dt>
        <dd>{{ details.requestIp }}</dd>
      </data-list>
    </data-box>
    <data-box
      v-if="formattedRequestBody"
      header="Request Body"
      :status="false"
    >
      <as-code>
        {{ formattedRequestBody }}
      </as-code>
    </data-box>
    <data-box
      v-if="formattedResponseBody"
      header="Response Body"
      :status="false"
    >
      <as-code>
        {{ formattedResponseBody }}
      </as-code>
    </data-box>
  </main-layout>
</template>

<style lang="scss" module>
:global {
  .el-card + .el-card {
    margin-top: 1rem;
  }
}
</style>
